// APP basics
export const SHOW_POPUP = 'SHOW_POPUP';
export const HIDE_POPUP = 'HIDE_POPUP';
export const SHOW_PROGRESS = 'SHOW_PROGRESS';
export const HIDE_PROGRESS = 'HIDE_PROGRESS';
export const SHOW_LOGIN = 'SHOW_LOGIN';
export const HIDE_LOGIN = 'HIDE_LOGIN';
export const SHOW_USER_POPUP = 'SHOW_USER_POPUP';
export const HIDE_USER_POPUP = 'HIDE_USER_POPUP';
export const SHOW_FORGOT = 'SHOW_FORGOT';
export const HIDE_FORGOT = 'HIDE_FORGOT';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAIL = 'UPDATE_COMPANY_FAIL';
export const SHOW_CONTEXT = 'SHOW_CONTEXT';
export const HIDE_CONTEXT = 'HIDE_CONTEXT';
export const STORE_STATUSBAR_DATA = 'STORE_STATUSBAR_DATA';
export const CLEAN_STATUSBAR_DATA = 'CLEAN_STATUSBAR_DATA';
export const SET_PASSWORD_REQUEST = 'SET_PASSWORD_REQUEST';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAIL = 'SET_PASSWORD_FAIL';
export const SHOW_SET_PASSWORD = 'SHOW_SET_PASSWORD';
export const HIDE_SET_PASSWORD = 'HIDE_SET_PASSWORD';
export const SAVE_NEW_REVISION = 'SAVE_NEW_REVISION';
export const STORE_FREIGHTS = 'STORE_FREIGHTS';

// User
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CURRENT_USER_REQUEST = 'CURRENT_USER_REQUEST';
export const CURRENT_USER_SUCCESS = 'CURRENT_USER_SUCCESS';
export const CURRENT_USER_FAIL = 'CURRENT_USER_FAIL';
export const COUNTRIES_REQUEST = 'COUNTRIES_REQUEST';
export const COUNTRIES_SUCCESS = 'COUNTRIES_SUCCESS';
export const COUNTRIES_FAIL = 'COUNTRIES_FAIL';
export const IMPERSONATE_FAIL = 'IMPERSONATE_FAIL';
export const IMPERSONATE_SUCCESS = 'IMPERSONATE_SUCCESS';
export const REFRESH_COMPANY_ID = 'REFRESH_COMPANY_ID';

// Manage notifications
export const NOTIF_GET_USERS_SUCCESS = 'NOTIF_GET_USERS_SUCCESS';
export const NOTIF_GET_NONUSERS_SUCCESS = 'NOTIF_GET_NONUSERS_SUCCESS';
export const NOTIF_GET_USERS_FAIL = 'NOTIF_GET_USERS_FAIL';
export const NOTIF_COMPANIES_SUCCESS = 'NOTIF_COMPANIES_SUCCESS';
export const NOTIF_CLEAR_USERS = 'NOTIF_CLEAR_USERS';
export const NOTIF_CLEAR_NONUSERS = 'NOTIF_CLEAR_NONUSERS';
export const NOTIF_SET_DATA = 'NOTIF_SET_DATA';
export const NOTIF_TOGGLE_CHECKBOX_ON = 'NOTIF_TOGGLE_CHECKBOX_ON';
export const NOTIF_TOGGLE_CHECKBOX_OFF = 'NOTIF_TOGGLE_CHECKBOX_OFF';
export const NONUSER_ADD = 'NONUSER_ADD';
export const NONUSER_JOIN = 'NONUSER_JOIN';
export const NONUSER_DELETE = 'NONUSER_DELETE';
export const NONUSER_POP = 'NONUSER_POP';
export const SHOW_CUSTOM_NOTIFICATION_POPUP = 'SHOW_CUSTOM_NOTIFICATION_POPUP';
export const HIDE_CUSTOM_NOTIFICATION_POPUP = 'HIDE_CUSTOM_NOTIFICATION_POPUP';

// Companies
export const COMPANIES_REQUEST = 'COMPANIES_REQUEST';
export const COMPANIES_SUCCESS = 'COMPANIES_SUCCESS';
export const COMPANIES_FAIL = 'COMPANIES_FAIL';
export const COMPANIES_MCPF_REQUEST = 'COMPANIES_MCPF_REQUEST';
export const COMPANIES_MCPF_SUCCESS = 'COMPANIES_MCPF_SUCCESS';
export const COMPANIES_MCPF_FAIL = 'COMPANIES_MCPF_FAIL';
export const COMPANY_APPROVE_REQUEST = 'COMPANY_APPROVE_REQUEST';
export const COMPANY_APPROVE_SUCCESS = 'COMPANY_APPROVE_SUCCESS';
export const COMPANY_APPROVE_FAIL = 'COMPANY_APPROVE_FAIL';
export const COMPANY_BLOCK_REQUEST = 'COMPANY_BLOCK_REQUEST';
export const COMPANY_BLOCK_SUCCESS = 'COMPANY_BLOCK_SUCCESS';
export const COMPANY_BLOCK_FAIL = 'COMPANY_BLOCK_FAIL';
export const COMPANY_UPDATE_ACCESS_REQUEST = 'COMPANY_UPDATE_ACCESS_REQUEST';
export const COMPANY_UPDATE_ACCESS_SUCCESS = 'COMPANY_UPDATE_ACCESS_SUCCESS';
export const COMPANY_UPDATE_ACCESS_FAIL = 'COMPANY_UPDATE_ACCESS_FAIL';

// Markets
export const SHOW_ONLINE_MARKET_LOG_LIST = 'SHOW_ONLINE_MARKET_LOG_LIST';
export const SHOW_ONLINE_MARKET_LOG_GRID = 'SHOW_ONLINE_MARKET_LOG_GRID';
export const HIDE_ONLINE_MARKET_LOG = 'HIDE_ONLINE_MARKET_LOG';
export const MARKETS_REQUEST = 'MARKETS_REQUEST';
export const MARKETS_SUCCESS = 'MARKETS_SUCCESS';
export const MARKETS_FAIL = 'MARKETS_FAIL';
export const PRODUCTS_REQUEST = 'PRODUCTS_REQUEST';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';
export const PRODUCTS_FAIL = 'PRODUCTS_FAIL';
export const MARKET_LOG_REQUEST = 'MARKET_LOG_REQUEST';
export const MARKET_LOG_SUCCESS = 'MARKET_LOG_SUCCESS';
export const MARKET_LOG_FAIL = 'MARKET_LOG_FAIL';
export const MARKET_LOG_STORE_ARGS = 'MARKET_LOG_STORE_ARGS';
export const MARKET_LOG_SET_SELECTED_VIEW = 'MARKET_LOG_SET_SELECTED_VIEW';
export const UPDATING_MARKET = 'UPDATING_MARKET';
export const UPDATING_PRODUCT = 'UPDATING_PRODUCT';
export const HIDE_PRODUCT = 'HIDE_PRODUCT';
export const UPDATING_FREIGHT_TYPE = 'UPDATING_FREIGHT_TYPE';
export const MARKETS_ALL_REQUEST = 'MARKETS_ALL_REQUEST';
export const MARKETS_ALL_SUCCESS = 'MARKETS_ALL_SUCCESS';
export const MARKETS_ALL_FAIL = 'MARKETS_ALL_FAIL';
export const SHOW_MANAGE_MARKET_POPUP = 'SHOW_MANAGE_MARKET_POPUP';
export const HIDE_MANAGE_MARKET_POPUP = 'HIDE_MANAGE_MARKET_POPUP';
export const SHOW_MANAGE_PRODUCT_POPUP = 'SHOW_MANAGE_PRODUCT_POPUP';
export const HIDE_MANAGE_PRODUCT_POPUP = 'HIDE_MANAGE_PRODUCT_POPUP';
export const HIDE_TAB = 'HIDE_TAB';
export const SHOW_STATUSBAR = 'SHOW_STATUSBAR';
export const HIDE_STATUSBAR = 'HIDE_STATUSBAR';
export const SHOW_MARKETLOG_FILTER = 'SHOW_MARKETLOG_FILTER';
export const HIDE_MARKETLOG_FILTER = 'HIDE_MARKETLOG_FILTER';
export const MARKET_RESET_STATE = 'MARKET_RESET_STATE';

// Save customised online market login
export const SHOW_SAVE_VIEW = 'SHOW_SAVE_VIEW';
export const HIDE_SAVE_VIEW = 'HIDE_SAVE_VIEW';
export const SAVE_VIEW_REQUEST = 'SAVE_VIEW_REQUEST';
export const SAVE_VIEW_SUCCESS = 'SAVE_VIEW_SUCCESS';
export const SAVE_VIEW_FAIL = 'SAVE_VIEW_FAIL';

export const SHOW_SAVE_GRID_VIEW = 'SHOW_SAVE_GRID_VIEW';
export const HIDE_SAVE_GRID_VIEW = 'HIDE_SAVE_GRID_VIEW';
export const SAVE_GRID_VIEW_REQUEST = 'SAVE_GRID_VIEW_REQUEST';
export const SAVE_GRID_VIEW_SUCCESS = 'SAVE_GRID_VIEW_SUCCESS';
export const SAVE_GRID_VIEW_FAIL = 'SAVE_GRID_VIEW_FAIL';

export const GET_CUSTOM_VIEW_REQUEST = 'GET_CUSTOM_VIEW_REQUEST';
export const GET_CUSTOM_VIEW_SUCCESS = 'GET_CUSTOM_VIEW_SUCCESS';
export const GET_CUSTOM_VIEW_FAIL = 'GET_CUSTOM_VIEW_FAIL';
export const DELETE_VIEW_REQUEST = 'DELETE_VIEW_REQUEST';
export const DELETE_VIEW_SUCCESS = 'DELETE_VIEW_SUCCESS';
export const DELETE_VIEW_FAIL = 'DELETE_VIEW_FAIL';

// Orders
export const ORDERS_REQUEST = 'ORDERS_REQUEST';
export const ORDERS_SUCCESS = 'ORDERS_SUCCESS';
export const ORDERS_FAIL = 'ORDERS_FAIL';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const CREATE_ORDER = 'CREATE_ORDER';
export const DELETE_ORDER = 'DELETE_ORDER';
export const SET_ORDER_POPUP_MODE = 'SET_ORDER_POPUP_MODE';
export const BEHALF_USERS_REQUEST = 'BEHALF_USERS_REQUEST';
export const BEHALF_USERS_SUCCESS = 'BEHALF_USERS_SUCCESS';
export const BEHALF_USERS_FAIL = 'BEHALF_USERS_FAIL';
export const BEHALF_USERS_EXTRA_REQUEST = 'BEHALF_USERS_EXTRA_REQUEST';
export const BEHALF_USERS_EXTRA_SUCCESS = 'BEHALF_USERS_EXTRA_SUCCESS';
export const BEHALF_USERS_EXTRA_FAIL = 'BEHALF_USERS_EXTRA_FAIL';
export const SHOW_ORDER_POPUP = 'SHOW_ORDER_POPUP';
export const DUPLICATE_ORDER_POPUP = 'DUPLICATE_ORDER_POPUP';
export const HIDE_ORDER_POPUP = 'HIDE_ORDER_POPUP';
export const SHOW_EXPIRED_ORDERS_POPUP = 'SHOW_EXPIRED_ORDERS_POPUP';
export const SHOW_COMPLETED_TRADES_POPUP = 'SHOW_COMPLETED_TRADES_POPUP';
export const HIDE_EXPIRED_ORDERS_POPUP = 'HIDE_EXPIRED_ORDERS_POPUP';
export const HIDE_COMPLETED_TRADES_POPUP = 'HIDE_COMPLETED_TRADES_POPUP';
export const SHOW_BID_POPUP = 'SHOW_BID_POPUP';
export const HIDE_BID_POPUP = 'HIDE_BID_POPUP';
export const UPDATE_BID = 'UPDATE_BID';
export const SET_SHOW_TRADED = 'SET_SHOW_TRADED';
export const USERS_WITH_NOTIFICATIONS_SUCCESS = 'USERS_WITH_NOTIFICATIONS_SUCCESS';
export const USERS_WITH_NOTIFICATIONS_FAIL = 'USERS_WITH_NOTIFICATIONS_FAIL';
export const ADD_MARKET_ORDER_NOTIFIKATION = 'ADD_ADD_MARKET_ORDER_NOTIFIKATION';
export const REMOVE_MARKET_ORDER_NOTIFIKATION = 'REMOVE_MARKET_ORDER_NOTIFIKATION';

// System log
export const SYSTEM_LOG_REQUEST = 'SYSTEM_LOG_REQUEST';
export const SYSTEM_LOG_SUCCESS = 'SYSTEM_LOG_SUCCESS';
export const SYSTEM_LOG_FAIL = 'SYSTEM_LOG_FAIL';
export const TRANSACTION_LOG_REQUEST = 'TRANSACTION_LOG_REQUEST';
export const TRANSACTION_LOG_SUCCESS = 'TRANSACTION_LOG_SUCCESS';
export const TRANSACTION_LOG_FAIL = 'TRANSACTION_LOG_FAIL';
export const USERS_LOG_REQUEST = 'USERS_LOG_REQUEST';
export const USERS_LOG_SUCCESS = 'USERS_LOG_SUCCESS';
export const USERS_LOG_FAIL = 'USERS_LOG_FAIL';

// Indices
export const INDICES_MARKETS_LIST_REQUEST = 'GET_INDICES_MARKETS_LIST_REQUEST';
export const INDICES_MARKETS_LIST_SUCCESS = 'GET_INDICES_MARKETS_LIST_SUCCESS';
export const INDICES_MARKETS_LIST_FAIL = 'GET_INDICES_MARKETS_LIST_FAIL';

export const SHOW_INDICES_POPUP = 'SHOW_INDICES_POPUP';
export const HIDE_INDICES_POPUP = 'HIDE_INDICES_POPUP';
export const ALL_INDICES_REQUEST = 'ALL_INDICES_REQUEST';
export const ALL_INDICES_SUCCESS = 'ALL_INDICES_SUCCESS';
export const ALL_INDICES_FAIL = 'ALL_INDICES_FAIL';
export const ADD_INDEX = 'ADD_INDEX';
export const DELETE_INDEX = 'DELETE_INDEX';
export const UPDATE_INDEX = 'UPDATE_INDEX';
export const INDEX_SETTLEMENT_REQUEST = 'INDEX_SETTLEMENT_REQUEST';
export const INDEX_SETTLEMENT_SUCCESS = 'INDEX_SETTLEMENT_SUCCESS';
export const INDEX_SETTLEMENT_FAIL = 'INDEX_SETTLEMENT_FAIL';

export const INDEX_SETTLEMENT_REPORT_REQUEST = 'INDEX_SETTLEMENT_REQUEST';
export const INDEX_SETTLEMENT_REPORT_SUCCESS = 'INDEX_SETTLEMENT_SUCCESS';
export const INDEX_SETTLEMENT_REPORT_FAIL = 'INDEX_SETTLEMENT_FAIL';

export const GET_SCHEDULE_REQUEST = 'GET_SCHEDULE_REQUEST';
export const GET_SCHEDULE_SUCCESS = 'GET_SCHEDULE_SUCCESS';
export const GET_SCHEDULE_FAIL = 'GET_SCHEDULE_FAIL';
export const SAVE_SCHEDULE_REQUEST = 'SAVE_SCHEDULE_REQUEST';
export const SET_MARKET_ID = 'SET_MARKET_ID';
export const SET_INDICES_YEAR = 'SET_INDICES_YEAR';
export const SET_SELECTED_FREQUENCY_TYPE = 'SET_SELECTED_FREQUENCY_TYPE';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_INDICES_MODAL_SETTING = 'SET_INDICES_MODAL_SETTING';
export const SET_SCHEDULE_UPDATED = 'SET_SCHEDULE_UPDATED';

// Freight types
export const FREIGHT_TYPES_REQUEST = 'FREIGHT_TYPES_REQUEST';
export const FREIGHT_TYPES_SUCCESS = 'FREIGHT_TYPES_SUCCESS';
export const FREIGHT_TYPES_FAIL = 'FREIGHT_TYPES_FAIL';
export const SHOW_FREIGHT_TYPES_POPUP = 'SHOW_FREIGHT_TYPES_POPUP';
export const HIDE_FREIGHT_TYPES_POPUP = 'HIDE_FREIGHT_TYPES_POPUP';

// Sockets
export const SOCKET_CONNECT_SEND = 'SOCKET_CONNECT_SEND';
export const SOCKET_CONNECT_SUCCESS = 'SOCKET_CONNECT_SUCCESS';
export const SOCKET_CONNECT_FAIL = 'SOCKET_CONNECT_FAIL';
export const SOCKET_NEW_MESSAGE = 'SOCKET_NEW_MESSAGE';



// WEBPACK FOOTER //
// ./source/constants/action-types.js